<template>
    <div>
        <div>
            <div class="form-actions flex justify-between">
                <div class="flex vx-col-action">
                    <vs-input icon-pack="feather" icon="icon-search" placeholder="Type here..." v-model="globalSearchTerm" class="is-label-placeholder searchBar-input" id="filter-text-box" v-on:input="onFilterTextBoxChanged()" />
                    <span class="br-line mr-2 ml-2"></span>
                </div>

                <div class="float-right flex">
                    <vs-chip class="chip-selected-rows" transparent closable color="primary" @click="deselectAllSelectedRows()">
                        {{ this.gridApi ? this.gridApi.getSelectedNodes().length : 0 }} Rows Selected
                    </vs-chip>
                    <vx-tooltip :text="!flags['selectedAll'][this.currentPage - 1] ? 'Select All' : 'Deselect All'" position="top">
                        <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" :icon="flags['selectedAll'][this.currentPage - 1] ? 'icon-check-square' : 'icon-square'" @click="toggleSelectAll()"></vs-button>
                    </vx-tooltip>

                    <span class="br-line-long mr-2 ml-2 h-60"></span>

                    <vx-tooltip v-if="isLocalRule" text="Add promo" position="top">
                        <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-plus" @click="addPromo()"></vs-button>
                    </vx-tooltip>

                    <vx-tooltip v-if="isLocalRule" text="Edit promo" position="top">
                        <vs-button color="dark" type="flat" icon-pack="feather" icon="icon-edit" @click="editPromo()" :disabled="this.selectedRowCount == 0 || this.selectedNonEditableRow"></vs-button>
                    </vx-tooltip>

                    <vx-tooltip v-if="isLocalRule" text="Duplicate promo" position="top">
                        <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-copy" @click="duplicatePromo()" :disabled="this.selectedRowCount !== 1"></vs-button>
                    </vx-tooltip>

                    <span class="br-line-long mr-2 ml-2 h-60"></span>

                    <vx-tooltip text="Download list" position="top">
                        <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-download" @click="downloadData()"></vs-button>
                    </vx-tooltip>

                    <vx-tooltip text="Reset Filters" position="top">
                        <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshPageWithFilters()"></vs-button>
                    </vx-tooltip>
                </div>
            </div>

            <div id="grid-loader" class="vx-card vs-con-loading__container">
                <ag-grid-vue 
                :gridOptions="gridOptions" 
                class="ag-theme-material w-100 ag-grid-table" 
                :columnDefs="columnDefs" 
                :defaultColDef="defaultColDef" 
                :components="components" 
                :rowData="tableData" 
                rowSelection="multiple" 
                :enableRangeSelection="true" 
                :suppressCopyRowsToClipboard="true" 
                :suppressDragLeaveHidesColumns="true" 
                :animateRows="false" 
                :floatingFilter="true" 
                :pagination="true" 
                :paginationPageSize="paginationPageSize" 
                :suppressPaginationPanel="true" 
                :suppressRowClickSelection="true" 
                :rowClassRules="rowClassRules" 
                :statusBar="statusBar" 
                :sideBar="sideBar" 
                :rowHeight="30" 
                :headerHeight="30" 
                :floatingFiltersHeight="35" 
                :checkboxSelection="true" 
                :enableBrowserTooltips="true"
                @filter-changed="onFilterChanged" 
                @row-selected="onRowSelected" 
                @pagination-changed="onPaginationChanged" 
                @column-resized="onColumnResized">
                </ag-grid-vue>
                <div class="vx-row py-5">
                    <div class="vx-col w-full">
                        <vs-pagination :total="totalPages" :max="maxPageNumbers" class="custom-pagination" v-model="currentPage" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

import CellRendererStatus from "@/components/ag-grid-tables/actions/CellRendererStatus.vue";
import CellRendererAgreementList from "@/components/ag-grid-tables/actions/CellRendererAgreementList.vue";

export default {
    name: "CnicPromoListComponent",
    components: {
        AgGridVue,
        CellRendererStatus,
        CellRendererAgreementList,
    },
    props: {
        expired: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedRowCount: "",
            selectedNonEditableRow: false,
            activePrompt: false,
            reject_comments: "",
            autoGroupColumnDef: null,
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: true,
                resizable: true,
                suppressMenu: true,
                suppressMovable: false,
                filterParams: {
                    suppressAndOrCondition: true,
                    newRowsAction: "keep",
                },
            },
            rowClassRules: null,
            statusBar: null,
            sideBar: null,
            columnDefs: null,
            tableData: null,
            selectedPromos: [],
            // Cell Renderer Components
            components: {
                CellRendererStatus,
            },
            globalSearchTerm: "",
            flags: {
                selectedAll: [],
            },
        };
    },
    watch: {
        windowWidth(val) {
            // Toggle colummn movable
            this.toggleColumnMovable(val);
            // Toggle colummn pinning
            this.toggleColumnPinned(val);
        },
    },
    computed: {
        windowWidth: function () {
            return this.$store.state.windowWidth;
        },
        user_id() {
            return JSON.parse(localStorage.getItem("userDetails")).id;
        },
        status() {
            // console.log(data && data ? data.status:'');
            return event.node;
        },
        paginationPageSize() {
            if (this.gridApi) {
                return this.gridApi.paginationGetPageSize();
            } else {
                return 15;
            }
        },
        totalPages() {
            if (this.gridApi) {
                return this.gridApi.paginationGetTotalPages();
            } else {
                return 0;
            }
        },
        scrollbarTag() {
            return this.$store.getters.scrollbarTag;
        },
        currentPage: {
            get() {
                if (this.gridApi)
                    return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
            },
        },
        validComment() {
            return this.reject_comments.length > 0;
        },
        rejectTitle() {
            return "Reject Selected Promos?";
        },
        yesText() {
            return "Yes";
        },
        noText() {
            return "No";
        },
        isLocalRule() {
            return this.$acl.check('isSuperAdmin') || this.$acl.check('isChannelAdmin') || this.$acl.check('isBIAdmin') || this.$acl.check('isChannelUser');
        }
    },
    methods: {
        onPageSizeChanged(newPageSize) {
            var value = document.getElementById("page-size").value;
            this.gridApi.paginationSetPageSize(Number(value));
        },
        onPaginationChanged() {
            // console.log('pagechanges');
            if (this.gridApi) {
                (this.totalRows = this.gridApi.paginationGetRowCount()),
                    (this.currentPageSize =
                        this.gridApi.paginationGetPageSize());
            }
        },
        onRowSelected(event) {
            var getStatus = this.gridApi
                .getSelectedNodes()
                .map((x) => x.data)
                .map((x) => x.status);
            getStatus.includes("expired")
                ? (this.selectedNonEditableRow = true)
                : (this.selectedNonEditableRow = false);
            if (event.node.selected) {
                // Push to selectedPromos
                this.selectedRowCount = this.gridApi.getSelectedNodes().length;
                if (this.selectedRowCount > 30) {
                    event.node.setSelected(false);

                    this.$vs.notify({
                        time: 5000,
                        color: "warning",
                        title: "Warning",
                        text: "You may select only upto 30 rows",
                    });
                }
            } else {
                // Remove from selectedPromos
                // this.removeFromArray(this.selectedPromos, event.node.childrenAfterGroup[0].data, 'id');
                this.selectedRowCount = this.gridApi.getSelectedNodes().length;
                // console.log('row-count', this.selectedRowCount);
            }
        },
        onFilterChanged() {
            this.deselectAllSelectedRows();
        },
        openLoadingInDiv() {
            this.$vs.loading({
                container: "#div-with-loading",
                scale: 0.8,
            });
        },
        hideLoadingInDiv() {
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        },
        populateTableData() {
            let self = this;

            let url = this.expired
                ? "/cnic-promos/expired"
                : "/cnic-promos";

            /* Get table data */
            this.$axiosSecure
                .get(url)
                .then((response) => {
                    //Passing premium value as Yes or No
                    // for (var key in response.data) {
                    //     if (response.data[key].premium == 0) {
                    //         response.data[key].premium = "No";
                    //     } else {
                    //         response.data[key].premium = "Yes";
                    //     }
                    // }
                    this.tableData = response.data;

                    if (this.gridApi) {
                        setTimeout(() => {
                            this.initSelectedAllFlag();

                            // NOTE: If logged in user is Erica, use name to apply filter, don't apply filter for any other logged in user
                            if(this.isAMExclusionActive()) {
                                var defaultFilter = {
                                    'am.name': {
                                        type: 'set',
                                        values: [process.env.VUE_APP_AM_EXCLUSION],
                                    },
                                };
                                this.gridApi.setFilterModel(defaultFilter);
                            }
                        }, 50);
                    }
                })
                .catch((error) => {
                    // Error notification
                    self.$vs.notify({
                        color: "danger",
                        title: "Something went wrong",
                        text: "Please contact the server admin",
                    });

                    console.log(error);

                    // Clear Listing Count
                    this.$store.dispatch("clearListingCount");
                });
        },
        toggleColumnMovable(val) {
            if (val <= 576) {
                this.defaultColDef["suppressMovable"] = true;
            } else {
                this.defaultColDef["suppressMovable"] = false;
            }
        },
        toggleColumnPinned(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("domain", null);
            } else {
                this.gridOptions.columnApi.setColumnPinned("domain", "left");
            }
        },
        onColumnResized() {
            this.gridApi.resetRowHeights();
        },
        sizeColumnsToFit() {
            this.gridApi.sizeColumnsToFit();
        },
        disableQueue() {
            // Old Logic
            this.rowClassRules = {
                "ag-row-disabled": 'data && (data.status == "edit pending")',
                "ag-checkbox-disabled":
                    'data && (data.status == "edit pending") && (data.status == "approval pending")',
                // "ag-row-red": 'data && (data.status == "expired")',
            };

            // New Logic (TODO: Add selection logic for Errored (exclusive selection))
            // this.rowClassRules = {
            //     'ag-checkbox-disabled' : function(data) {
            //         return (data.data && (data.data.status == "edit pending") || (data.data.status == "approval pending"));
            //     },
            //     'ag-row-disabled': function(data) {
            //         return (data.data && (data.data.status == "edit pending") || (data.data.status == "approval pending"));
            //     }
            // };
        },
        // Refresh the page withou resetting filters
        refreshPage() {
            // this.$root.$emit('refreshPage');
            this.initSelectedAllFlag();
            // Reset filters
            // this.gridApi.setFilterModel(null);
            // Reset selection
            this.gridApi.deselectAll();
            // Reset sort
            this.gridApi.setSortModel(null);
            // Table Data AXIOS Call
            this.populateTableData();
        },
        // With filters for when we want to reset filters
        refreshPageWithFilters() {
            this.initSelectedAllFlag();
            // Reset filters
            this.gridApi.setFilterModel(null);
            // Reset selection
            this.gridApi.deselectAll();
            // Reset sort
            this.gridApi.setSortModel(null);
            // Table Data AXIOS Call
            this.populateTableData();
        },
        gridSelectAll() {
            this.gridApi.forEachNodeAfterFilter((node) => {
                if (
                    !(
                        node.data.status == "new approved" ||
                        node.data.status == "rejected" ||
                        node.data.status == "error"
                    )
                ) {
                    if (
                        node["rowIndex"] >=
                            (this.currentPage - 1) *
                                this.gridApi.paginationGetPageSize() &&
                        node["rowIndex"] <
                            this.currentPage *
                                this.gridApi.paginationGetPageSize()
                    ) {
                        node.setSelected(true);
                    }
                }
            });
        },
        gridDeselectAll() {
            this.gridApi.forEachNodeAfterFilter((node) => {
                if (
                    node["rowIndex"] >=
                        (this.currentPage - 1) *
                            this.gridApi.paginationGetPageSize() &&
                    node["rowIndex"] <
                        this.currentPage * this.gridApi.paginationGetPageSize()
                ) {
                    node.setSelected(false);
                }
            });
        },
        addPromo() {
            this.$router.push("/promos/add/cnic");
        },
        editPromo() {
            let extended = false;

            if (this.expired) {
                extended = true;
            }

            var selectedRowsData = this.gridApi.getSelectedNodes();
            this.$root.$emit(
                "selectedGroupEditCNIC",
                selectedRowsData,
                extended
            );
            this.refreshPage();
        },
        duplicatePromo() {
            // console.log('selected', this.gridApi.getSelectedNodes());
            var selectedRowsData = this.gridApi.getSelectedNodes();
            // this.$root.$emit('selectedDuplicate', selectedRowsData);
            this.$root.$emit("duplicatePromoCNIC", selectedRowsData);
        },
        downloadData() {
            this.$root.$emit("downloadCNICPage");
        },
        toggleSelectAll() {
            if (this.flags["selectedAll"][this.currentPage - 1]) {
                this.gridDeselectAll();
                this.flags["selectedAll"][this.currentPage - 1] =
                    !this.flags["selectedAll"][this.currentPage - 1];
            } else {
                this.selectedRowCount = this.gridApi.getSelectedNodes().length;
                if (
                    this.selectedRowCount < 30 &&
                    this.selectedRowCount + 15 <= 30
                ) {
                    this.gridSelectAll();
                    this.flags["selectedAll"][this.currentPage - 1] =
                        !this.flags["selectedAll"][this.currentPage - 1];
                } else {
                    this.$vs.notify({
                        time: 5000,
                        color: "warning",
                        title: "Warning",
                        text: "You may select only upto 30 rows",
                    });
                }
            }
        },
        onFilterTextBoxChanged() {
            this.gridApi.setQuickFilter(
                document.getElementById("filter-text-box").value
            );
            this.deselectAllSelectedRows();
        },
        initSelectedAllFlag() {
            if (this.tableData.length) {
                for (let i = 0; i < this.gridApi.paginationGetTotalPages(); i++) {
                    this.flags["selectedAll"].push(false);
                }
            }
        },
        deselectAllSelectedRows() {
            this.gridApi.deselectAll();

            this.flags["selectedAll"].fill(false);
        },
    },
    beforeMount() {
        this.disableQueue();

        // Table Data AXIOS Call
        this.populateTableData();

        // Reset movable columns on mobile
        this.toggleColumnMovable(this.windowWidth);

        (this.columnDefs = [
            {
                headerName: "Promo Name",
                field: "promo_name",
                filter: "agSetColumnFilter",
                checkboxSelection: true,
                minWidth: 280,
                width: 250,
                pinned: "left",
                tooltipField: "promo_name"
                // cellClass: "cellCustomWrap",
            },
            {
                headerName: "Registrar Name",
                field: "new_registrar.unique_registrar.name",
                filter: "agSetColumnFilter",
                minWidth: 150,
                width: 250,
                pinned: "left",
                tooltipField: "new_registrar.unique_registrar.name"
                // cellClass: "cellCustomWrap",
            },
            {
                headerName: "AM",
                field: "am.name",
                filter: "agSetColumnFilter",
                minWidth: 150,
                width: 250,
                suppressFilter: this.isAMExclusionActive() ? true : false
            },
            {
                headerName: "Status",
                field: "status",
                filter: "agSetColumnFilter",
                cellRendererFramework: "CellRendererStatus",
                minWidth: 130,
            },
            {
                headerName: "TLD",
                field: "tld.tld_name",
                filter: "agSetColumnFilter",
                minWidth: 100,
                width: 150,
            },
            {
                headerName: "CNIC ID",
                field: "new_registrar.cnic_id",
                filter: "agSetColumnFilter",
                minWidth: 150,
                width: 150,
            },
            {
                headerName: "Amount",
                field: "effective_price_amt",
                filter: "agTextColumnFilter",
                minWidth: 130,
            },
            {
                headerName: "Percentage",
                field: "effective_price_per",
                filter: "agTextColumnFilter",
                minWidth: 130,
            },
            {
                headerName: "Start Date",
                field: "start_date",
                filter: "agDateColumnFilter",
                minWidth: 175,
                filterParams: {
                    comparator: function (
                        filterLocalDateAtMidnight,
                        cellValue
                    ) {
                        let dateAsString = cellValue;
                        if (dateAsString == null) return -1;
                        let dateParts = dateAsString.split("-");
                        let cellDate = new Date(
                            Number(dateParts[0]),
                            Number(dateParts[1]) - 1,
                            Number(dateParts[2])
                        );
                        if (
                            filterLocalDateAtMidnight.getTime() ===
                            cellDate.getTime()
                        ) {
                            return 0;
                        }
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate > filterLocalDateAtMidnight) {
                            return 1;
                        }
                    },
                    browserDatePicker: true,
                },
            },
            {
                headerName: "End Date",
                field: "end_date",
                filter: "agDateColumnFilter",
                minWidth: 175,
                filterParams: {
                    comparator: function (
                        filterLocalDateAtMidnight,
                        cellValue
                    ) {
                        let dateAsString = cellValue;
                        if (dateAsString == null) return -1;
                        let dateParts = dateAsString.split("-");
                        let cellDate = new Date(
                            Number(dateParts[0]),
                            Number(dateParts[1]) - 1,
                            Number(dateParts[2])
                        );
                        if (
                            filterLocalDateAtMidnight.getTime() ===
                            cellDate.getTime()
                        ) {
                            return 0;
                        }
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate > filterLocalDateAtMidnight) {
                            return 1;
                        }
                    },
                    browserDatePicker: true,
                },
            },
            {
                headerName: "Type",
                field: "type_of_reg",
                filter: "agSetColumnFilter",
                minWidth: 150,
            },
            {
                headerName: "Registrar ID",
                field: "registrar.cnic_id",
                filter: "agTextColumnFilter",
                minWidth: 150,
                hide: true,
            },
            {
                headerName: "Premium",
                field: "premium",
                filter: "agSetColumnFilter",
                minWidth: 150,
                hide: true,
                valueGetter: (data) => {
                    return data.data.premium == 1 ? "Yes" : "No"
                },
                cellRenderer: (data) => {
                    return data.data.premium == 1 ? "Yes" : "No"
                }
            },
            {
                headerName: "Start Time",
                field: "start_time",
                filter: "agTextColumnFilter",
                minWidth: 150,
                hide: true,
            },
            {
                headerName: "End Time",
                field: "end_time",
                filter: "agTextColumnFilter",
                minWidth: 150,
                hide: true,
            },

            {
                headerName: "Created By",
                field: "user.name",
                filter: "agSetColumnFilter",
                minWidth: 150,
                hide: true,
            },
            {
                headerName: "Agreements",
                field: "dropbox_detail",
                filter: "agSetColumnFilter",
                cellRendererFramework: "CellRendererAgreementList",
                cellRendererParams: {
                    source: "cnic",
                },
                minWidth: 130,
            },
            {
                headerName: "Comments",
                field: "comments",
                filter: "agTextColumnFilter",
                minWidth: 150,
                width: 100,
                tooltipField: "comments"
                // cellClass: "cellCustomWrap",
            },
        ]),
            // Set Grid sidebar
            (this.sideBar = {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel",
                        toolPanelParams: {
                            suppressRowGroups: true,
                            suppressValues: true,
                            suppressPivots: true,
                            suppressPivotMode: true,
                            suppressSideButtons: true,
                            suppressColumnSelectAll: true,
                            suppressColumnExpandAll: true,
                        },
                    },
                ],
            });
    },
    mounted() {
        this.gridApi = this.gridOptions.api;

        //agigrid loader
        this.gridApi.showLoadingOverlay();

        // Resize to fit columns
        this.sizeColumnsToFit();

        // Reset pinned columns on mobile
        this.toggleColumnPinned(this.windowWidth);

        // Page Download Event
        this.$root.$on("downloadCNICPage", () => {
            // AgGrid CSV Export
            this.gridApi.exportDataAsCsv();
        });

        this.$root.$on("tableRefresh", () => {
            this.refreshPage();
        });
    },
    destroyed() {
        // Clear Listing Count
        this.$store.dispatch("clearListingCount");

        // Unbind Button Event Listeners
        this.$root.$off("tableRefresh");
    },
};
</script>

<style lang="scss">
.ag-selection-checkbox {
    display: flex;
    align-items: center;
    height: 36px;
}

.ag-row-disabled,
.ag-checkbox-disabled .ag-group-checkbox {
    pointer-events: none;
}

.ag-row-disabled .ag-group-checkbox,
.ag-checkbox-disabled .ag-group-checkbox {
    opacity: 0.3;
}

.ag-row-level-1 .ag-group-value,
.text-capitalize input {
    text-transform: capitalize;
}

//Hide grouping arrow
.ag-group-expanded,
.ag-group-contracted {
    display: none !important;
}

.ag-group-checkbox {
    margin-left: 0 !important;
}

.text-capitalize {
    text-transform: capitalize;
}
</style>
